export default __webpack_public_path__ + "static/media/insert.091b0798.svg";